import React, { createContext, useCallback } from 'react';
import axios from 'axios';
// WAS (backlog #160 öncesi): import {NODE_BACKEND_API_URL, NODE_BACKEND_API_PORT} from "../BackendConstants";
import { JAVA_BACKEND_API_URL, getAuthHeader } from "../BackendConstants";

/**
 * E-posta Şablonları (email_template). Backlog #160 (2026-10-10): eski Node ucu (/api/emailtemplates)
 * ölüydü (404); artık FDS-Backend EmailController, personele açık:
 *   GET /email/templates?page&limit&search → { data, page, limit, total, totalPages }
 *   POST /email/templates  { title, content }   PUT /email/templates/{id}   DELETE /email/templates/{id}
 */

const EmailTemplateContext = createContext();

export const EmailTemplateProvider = ({ children }) => {

    // WAS: emailTemplates: `${NODE_BACKEND_API_URL}:${NODE_BACKEND_API_PORT}/api/emailtemplates`,
    const api = {
        emailTemplates: `${JAVA_BACKEND_API_URL}/email/templates`,
    };

    const getEmailTemplates = useCallback(async (page = 1, limit = 10, search = '') => {
        try {
            const response = await axios.get(api.emailTemplates, {
                params: {
                    page,
                    limit,
                    search,
                    // 2026-10-30: GET /email/templates answers BOTH kinds when no scope is given (the system mails too, they have their own tab); this list is the free ones
                    scope: 'DENETMEN'
                },
                headers: getAuthHeader(),   // #160
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching email templates:', error);
            throw error;
        }
    }, [api.emailTemplates]);

    const addEmailTemplate = useCallback(async (newEmailTemplate) => {
        try {
            // WAS: const response = await axios.post(api.emailTemplates, newEmailTemplate);
            const response = await axios.post(api.emailTemplates, newEmailTemplate, { headers: getAuthHeader() });
            return response.data;
        } catch (error) {
            console.error('Error adding email template:', error);
            throw error;
        }
    }, [api.emailTemplates]);

    const updateEmailTemplate = useCallback(async (id, updatedEmailTemplate) => {
        try {
            // WAS: const response = await axios.put(`${api.emailTemplates}/${id}`, updatedEmailTemplate);
            const response = await axios.put(`${api.emailTemplates}/${id}`, updatedEmailTemplate, { headers: getAuthHeader() });
            return response.data;
        } catch (error) {
            console.error('Error updating email template:', error);
            throw error;
        }
    }, [api.emailTemplates]);

    const deleteEmailTemplate = useCallback(async (id) => {
        try {
            // WAS: await axios.delete(`${api.emailTemplates}/${id}`);
            await axios.delete(`${api.emailTemplates}/${id}`, { headers: getAuthHeader() });
        } catch (error) {
            console.error('Error deleting email template:', error);
            throw error;
        }
    }, [api.emailTemplates]);

    const saveOrUpdateTemplate = useCallback(async (templateId, title, content) => {
        const templateData = { title, content };
        
        if (templateId) {
            // Güncelleme işlemi
            return updateEmailTemplate(templateId, templateData);
        } else {
            // Yeni ekleme işlemi
            return addEmailTemplate(templateData);
        }
    }, [addEmailTemplate, updateEmailTemplate]);

    return (
        <EmailTemplateContext.Provider value={{ 
            getEmailTemplates, addEmailTemplate, updateEmailTemplate, deleteEmailTemplate,saveOrUpdateTemplate 
        }}>
            {children}
        </EmailTemplateContext.Provider>
    );
};

export default EmailTemplateContext;
